export const MULTI_BODIED_MACRO_FF = 'confluence.frontend.ecosystem.multi-bodied-macro';
